export class ServiceProviderDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ssoIntegrationSettings",
            "baseName": "ssoIntegrationSettings",
            "type": "SsoIntegrationSettings",
            "format": ""
        },
        {
            "name": "pubCertificate",
            "baseName": "pubCertificate",
            "type": "string",
            "format": ""
        },
        {
            "name": "idpInitiatedLoginUrl",
            "baseName": "idpInitiatedLoginUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ServiceProviderDetails.attributeTypeMap;
    }
    constructor() {
    }
}
